export function getCountryCodeByIp() {
    return fetch('https://ipinfo.io/json', {
        headers: {
            Accept: 'application/json',
        },
        referrerPolicy: 'no-referrer',
    })
        .then(function (response) { return response.json(); })
        .then(function (json) { return json.country; });
}
